import React from 'react';
import { Drawer, List, Button, Tooltip } from 'antd';
import { DownloadOutlined, EyeOutlined, HistoryOutlined } from '@ant-design/icons';
import './DigitalProductVersionHistory.css';

export default function DigitalProductVersionHistory({ 
  versions, 
  selectedVersion, 
  onVersionSelect,
  visible,
  onClose
}) {
  if (!versions || versions.length === 0) {
    return null;
  }

  const formatDate = (timestamp) => {
    if (!timestamp) return 'Unknown';
    if (timestamp.toDate) {
      return timestamp.toDate().toLocaleString();
    }
    if (timestamp instanceof Date) {
      return timestamp.toLocaleString();
    }
    if (typeof timestamp === 'string') {
      return new Date(timestamp).toLocaleString();
    }
    return 'Invalid date';
  };

  // Sort versions by version number in descending order (highest version first)
  const sortedVersions = [...versions].sort((a, b) => {
    return (b.version || 0) - (a.version || 0);
  });

  return (
    <>
      <button
        className="btn d-flex align-items-center"
        onClick={onClose}
        style={{ backgroundColor: '#39325b', color: 'white' }}
      >
        <HistoryOutlined className="me-2" />
        Version History ({sortedVersions.length})
      </button>

      <Drawer
        title={
          <div className="d-flex align-items-center">
            <HistoryOutlined className="me-2" />
            <span>Version History</span>
          </div>
        }
        placement="right"
        onClose={onClose}
        open={visible}
        width={400}
        className="version-history-drawer"
        style={{ position: 'absolute', top: 0, right: 0, height: '100%' }}
      >
        <List
          dataSource={sortedVersions}
          renderItem={(version) => (
            <List.Item
              className={`version-item ${selectedVersion?.id === version.id ? 'selected' : ''}`}
              actions={[
                <Tooltip title="View">
                  <Button
                    type="text"
                    icon={<EyeOutlined />}
                    onClick={() => {
                      onVersionSelect(version);
                      onClose();
                    }}
                  />
                </Tooltip>,
                <Tooltip title="Download">
                  <Button
                    type="text"
                    icon={<DownloadOutlined />}
                    href={version.downloadURL}
                    target="_blank"
                    rel="noopener noreferrer"
                  />
                </Tooltip>
              ]}
            >
              <List.Item.Meta
                title={`Version ${version.version}`}
                description={
                  <div>
                    <p className="mb-1">
                      <strong>Uploaded by:</strong> {version.uploadedBy || 'Unknown'}
                    </p>
                    <p className="mb-1">
                      <strong>Date:</strong> {formatDate(version.uploadedAt)}
                    </p>
                    <p className="mb-0">
                      <strong>File:</strong> {version.fileName} ({(version.fileSize / 1024).toFixed(2)} KB)
                    </p>
                  </div>
                }
              />
            </List.Item>
          )}
        />
      </Drawer>
    </>
  );
} 